import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../services/api';

const TutorialVideoContext = createContext({});

export function TutorialVideoProvider({ children }) {
  const [videos, setVideos] = useState({});

  const fetchVideos = useCallback(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    api.get('/tutorial-videos/')
      .then(res => {
        const map = {};
        res.data.forEach(v => {
          if (!map[v.section_key]) map[v.section_key] = [];
          map[v.section_key].push(v);
        });
        setVideos(map);
      })
      .catch(() => {
        // Fail silently — buttons just won't render if fetch fails
      });
  }, []);

  const clearVideos = useCallback(() => {
    setVideos({});
  }, []);

  // Fetch on mount (handles hard refresh when token already exists)
  useEffect(() => {
    fetchVideos();
  }, [fetchVideos]);

  const value = {
    videos,
    refreshVideos: fetchVideos,
    clearVideos,
  };

  return (
    <TutorialVideoContext.Provider value={value}>
      {children}
    </TutorialVideoContext.Provider>
  );
}

export function useTutorialVideos() {
  return useContext(TutorialVideoContext);
}
